<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M1.5625 5.1875C1.5625 3.46161 2.96161 2.0625 4.6875 2.0625H6.11628C7.0125 2.0625 7.79372 2.67246 8.01109 3.54192L9.16296 8.14941C9.35355 8.91177 9.06868 9.71411 8.44002 10.1856L7.0925 11.1962C6.95257 11.3012 6.92215 11.4549 6.96146 11.5622C8.14428 14.7911 10.7089 17.3557 13.9378 18.5385C14.0451 18.5778 14.1988 18.5474 14.3038 18.4075L15.3144 17.06C15.7859 16.4313 16.5882 16.1465 17.3506 16.337L21.9581 17.4889C22.8275 17.7063 23.4375 18.4875 23.4375 19.3837V20.8125C23.4375 22.5384 22.0384 23.9375 20.3125 23.9375H17.9688C8.90783 23.9375 1.5625 16.5922 1.5625 7.53125V5.1875Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPhone',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>